import { StripePaymentMethodType } from "@/gql/graphql";
import { StripePaymentMethod } from "@/gql/schema";
import { CreditCardIcon } from "@heroicons/react/24/outline";
import { IconMenuActions } from "@/lib/Components/Actions/IconMenuActions";
import { useStripePaymentMethodActions } from "@/app/Stripe/StripePaymentMethods/Hooks/useStripePaymentMethodActions";

export function StripePaymentMethodListItem({
  paymentMethod,
}: {
  paymentMethod: Pick<
    StripePaymentMethod,
    | "id"
    | "card_last_four"
    | "card_brand"
    | "card_exp_month"
    | "card_exp_year"
    | "type"
    | "is_primary"
  >;
}) {
  const getActions = useStripePaymentMethodActions();

  if (paymentMethod.type !== StripePaymentMethodType.Card) {
    throw new Error("Unsupported payment method type " + paymentMethod.type);
  }

  return (
    <li
      className={`relative overflow-hidden rounded-lg border bg-white p-5 shadow-sm transition-shadow hover:shadow-md ${
        paymentMethod.is_primary
          ? "border-blue-200 ring-1 ring-blue-100"
          : "border-gray-200"
      }`}
    >
      {paymentMethod.is_primary ? (
        <div className="absolute right-0 top-0">
          <div className="bg-blue-500 px-3 py-1 text-xs font-medium text-white">
            Primary
          </div>
        </div>
      ) : null}

      <div className="mb-4 flex items-center justify-between">
        <div className="flex h-10 w-14 items-center justify-center rounded-md bg-gradient-to-br from-gray-700 to-gray-900">
          <CreditCardIcon className="h-6 w-6 text-white" />
        </div>
        <IconMenuActions actions={getActions(paymentMethod)} />
      </div>

      <div className="space-y-2">
        <p className="whitespace-nowrap font-mono text-base tracking-wider text-gray-800">
          •••• {paymentMethod.card_last_four}
        </p>
        <div className="flex items-center justify-between">
          <span className="text-sm font-medium capitalize text-gray-700">
            {paymentMethod.card_brand}
          </span>
          <span className="text-sm text-gray-500">
            {paymentMethod.card_exp_month}/{paymentMethod.card_exp_year}
          </span>
        </div>
      </div>
    </li>
  );
}
